/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE } from './types';
import { IUser } from '../../../models/Users/UserContracts';
import { IPage } from '../../../models/AssignedUsers/AssignedUsers';
import { pageData } from '../../../components/RoleDetails/constants';

export const userReducerInitialState: {
  users: IUser[];
  page: IPage;
  loading: boolean;
  error: null;
} = {
  users: [],
  page: pageData,
  loading: false,
  error: null
};

export const assignedUsersReducer = (state = userReducerInitialState, action: any) => {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        page: action.page,
        loading: false,
        error: null
      };

    case FETCH_USERS_FAILURE:
      return {
        ...state,
        users: [],
        page: pageData,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};
